// import {
//     temAcesso
// } from '@/shared/auth/temAcesso'
import projetosRotas from './projetos/ProjetosRotas'
import etapasRotas from './etapas/EtapasRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'

export default {
    path: 'fornecedor',
    name: 'Sgtec_Fornecedor',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    // beforeEnter: (to, from, next) => {
    //     if (to.name === 'Gestores') {
    //         if (temAcesso('UABS-00')) {
    //             next()
    //         }
    //     } else {
    //         next()
    //     }
    // },
    children: [
        projetosRotas,
        ...etapasRotas,
        pagamentosRotas
    ]
}
